import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { Button, Image } from 'react-bootstrap';
import $ from 'jquery';
import Calendar from '../../../../assets/img/calendar.svg'
// Import Style
import './DateRangePicker.scss';


class DatePicker extends Component {
  static defaultProps = {
    dateFormat: 'DD MMM YYYY',
    value: {
      startDate: moment().subtract(3, 'months').startOf('day'),
      endDate: moment().endOf('day'),
    },
  };
  constructor(props) {
    super(props);
    this.state = {
      fixStartDate: null,
      fixEndDate: null,
      label: '',
      ranges: {
        '1 week': [moment().subtract(1, 'week'), moment()],
        '2 weeks': [moment().subtract(2, 'weeks'), moment()],
        '1 month': [moment().subtract(1, 'months'), moment()],
        '3 months': [moment().subtract(3, 'months'), moment()],
        '6 months': [moment().subtract(6, 'months'), moment()],
        '1 year': [moment().subtract(1, 'year'), moment()]
      }
    };

    this.pickerRef = createRef();
  }

  componentDidMount() {
    this.setLabel();

    this.addButtons();
    this.addCheckBoxes();
    this.notificationBar();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value != this.props.value || prevProps.dateFormat != this.props.dateFormat) {
      this.setLabel();
      this.setCheckBoxes();
    }
  }

  notificationBar() {
    const calendarContainer = $('.daterangepicker .ranges');
    // Remove any existing notification first
    $('.daterangepicker .notification').remove();
    
    const customDate = this.state.fixStartDate && this.state.fixEndDate;
    
    const notification = $(
      `<div class="notification">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM11 9H13V7H11V9Z" fill="#FEFEFE"/>
        </svg>
        ${customDate 
          ? 'You have selected a fixed period. To enable a rolling period, choose one of the preset options like 1 week, 2 weeks, 1 month, etc.'
          : 'You have rolling period enabled. Your selected period will be updated tomorrow. Fix dates to disable the rolling period.'
        }
      </div>`
    )
    notification.insertBefore(calendarContainer);
  }

  addButtons() {
    // Add Today button handler
    const calendarContainer = $('.daterangepicker .calendar .daterangepicker_input');
    const btn = $(
      `<div class="btn-today-container"><Button class="todayBtn btn btn-sm btn-secondary" type="button">Today</Button></div>`
    );

    btn.children('button').on('click', ev => {
      const input = $(ev.target)
        .parents('.calendar')
        .find('input');
      input.val(moment().format(this.props.dateFormat));
      input.trigger('change.daterangepicker');
      this.handleDatesChanged();
    });
    btn.appendTo(calendarContainer);

    // Override default range buttons behavior except for Custom Range
    const rangeButtons = $('.daterangepicker .ranges li:not(:contains("Custom Range"))');
    rangeButtons.off('mousedown').on('mousedown', ev => {
      ev.preventDefault();
      ev.stopPropagation();

      const picker = this.pickerRef.current.$picker.data('daterangepicker');
      const rangeName = $(ev.target).text();
      const range = picker.ranges[rangeName];
      
      if (range) {
        picker.setStartDate(range[0]);
        picker.setEndDate(range[1]);
        picker.updateCalendars();
      }
      
      // Reset fixed dates and state when using predefined ranges
      const fixStartCheckbox = $('.calendar.left .btn-container input');
      const fixEndCheckbox = $('.calendar.right .btn-container input');
      fixStartCheckbox[0].checked = false;
      fixEndCheckbox[0].checked = false;
      fixStartCheckbox[0].disabled = false;
      fixEndCheckbox[0].disabled = false;

      this.setState({
        fixStartDate: false,
        fixEndDate: false
      }, () => {
        this.handleDatesChanged();
        this.notificationBar();
      });
      
      return false;
    });

    // Add handler for Custom Range button
    const customRangeButton = $('.daterangepicker .ranges li:contains("Custom Range")');
    customRangeButton.on('mousedown', () => {
      const fixStartCheckbox = $('.calendar.left .btn-container input');
      const fixEndCheckbox = $('.calendar.right .btn-container input');
      
      fixStartCheckbox[0].checked = true;
      fixEndCheckbox[0].checked = true;
      
      this.setState({
        fixStartDate: true,
        fixEndDate: true
      }, () => {
        this.notificationBar();
      });
    });

    // Prevent default click behavior for predefined ranges only
    rangeButtons.off('click').on('click', ev => {
      ev.preventDefault();
      ev.stopPropagation();
      return false;
    });
  }

  addCheckBoxes() {
    const leftContainer = $('.calendar.left');
    const rightContainer = $('.calendar.right');

    const checkbox = (id, label, note) => $(
      `
      <div class="btn-container">
        <div class="calendar_check_box">
          <input name="${id}" type="checkbox"/>
          <span class="check_mark">
            <svg width="10px" height="10px" viewBox="0 0 12 10">
              <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
            </svg>
          </span>
          <label class="btn btn-secondary" title="${note}" for="${id}">${label}</label>
        </div>
        <div class="info">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clip-path="url(#clip0_4826_13340)">
              <path d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z" fill="#668CB3"/>
              <path d="M8.93 6.588L6.64 6.875L6.558 7.255L7.008 7.338C7.302 7.408 7.36 7.514 7.296 7.807L6.558 11.275C6.364 12.172 6.663 12.594 7.366 12.594C7.911 12.594 8.544 12.342 8.831 11.996L8.919 11.58C8.719 11.756 8.427 11.826 8.233 11.826C7.958 11.826 7.858 11.633 7.929 11.293L8.93 6.588ZM9 4.5C9 4.76522 8.89464 5.01957 8.70711 5.20711C8.51957 5.39464 8.26522 5.5 8 5.5C7.73478 5.5 7.48043 5.39464 7.29289 5.20711C7.10536 5.01957 7 4.76522 7 4.5C7 4.23478 7.10536 3.98043 7.29289 3.79289C7.48043 3.60536 7.73478 3.5 8 3.5C8.26522 3.5 8.51957 3.60536 8.70711 3.79289C8.89464 3.98043 9 4.23478 9 4.5Z" fill="#668CB3"/>
            </g>
            <defs>
              <clipPath id="clip0_4826_13340">
                <rect width="16" height="16" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          Disables rolling period
        </div>
      </div>
      `
    );

    const startDateCheckbox = checkbox('checkbox-1', 'Fix start date', 'Your dashboard view will fix the start date when enabled');
    const endDateCheckbox = checkbox('checkbox-2', 'Fix end date', 'Your dashboard view will fix the end date when enabled');

    const calendar = $('.calendar');
    calendar
      .on('mousedown.daterangepicker', 'td.available', ev => {
        this.handleDatesChanged();
        this.notificationBar();
      })
    calendar.find('.daterangepicker_input input')
      .on('change', ev => {
        this.handleDatesChanged();
        this.notificationBar();
      })
      .on('keydown', ev => {
        if (ev.key === 'Enter') {
          this.handleDatesChanged();
          this.notificationBar();
        }
      })

    startDateCheckbox.on('click', ev => {
      ev.stopPropagation();
      const fixStartCheckbox = $('.calendar.left .btn-container input');
      if (!fixStartCheckbox[0].disabled) {
        fixStartCheckbox[0].checked = !fixStartCheckbox[0].checked;
        this.setState({
          fixStartDate: fixStartCheckbox[0].checked
        }, () => {
          this.notificationBar();
        });
      }
    });
    endDateCheckbox.on('click', ev => {
      ev.stopPropagation();
      const fixEndCheckbox = $('.calendar.right .btn-container input');
      const fixStartCheckbox = $('.calendar.left .btn-container input');
      
      if (!fixEndCheckbox[0].disabled) {
        fixEndCheckbox[0].checked = !fixEndCheckbox[0].checked;
      }
      
      if (fixEndCheckbox[0].checked) {
        fixStartCheckbox[0].checked = true;
        fixStartCheckbox[0].disabled = true;
        this.setState({
          fixStartDate: true,
          fixEndDate: true
        }, () => {
          this.notificationBar();
        });
      } else {
        fixStartCheckbox[0].disabled = false;
        fixStartCheckbox[0].checked = this.state.fixStartDate;
        this.setState({
          fixEndDate: false
        }, () => {
          this.notificationBar();
        });
      }
    });

    startDateCheckbox.appendTo(leftContainer);
    endDateCheckbox.appendTo(rightContainer);

    this.setCheckBoxes();
  }

  setCheckBoxes() {
    const { value } = this.props;
    const fixStartDate = value.fixedStartDate || value.customDate;
    const fixEndDate = value.customDate;
    const endDateMatchToday = moment(value.endDate).isSame(moment(), 'days');
    const fixStartCheckbox = $('.calendar.left .btn-container input');
    const fixEndCheckbox = $('.calendar.right .btn-container input');

    fixStartCheckbox[0].disabled = value.customDate;
    fixStartCheckbox[0].checked = fixStartDate;
    fixEndCheckbox[0].disabled = !endDateMatchToday;
    fixEndCheckbox[0].checked = fixEndDate;

    this.setState({
      fixStartDate,
      fixEndDate,
    }, () => {      
      this.notificationBar();
    });
  }

  setLabel() {
    const { value, dateFormat } = this.props;
    let label;

    let start = moment(value.startDate).format(dateFormat);
    let end = moment(value.endDate).format(dateFormat);
    label = start + ' - ' + end;

    this.setState({ label });
  }

  handleDatesChanged = () => {
    if (this.pickerRef.current) {
      const picker = this.pickerRef.current.$picker.data('daterangepicker');
      const endDateMatchToday = moment(picker.endDate).isSame(moment(), 'days');
      const fixStartCheckbox = $('.calendar.left .btn-container input');
      const fixEndCheckbox = $('.calendar.right .btn-container input');
      fixEndCheckbox[0].disabled = !endDateMatchToday;
      fixEndCheckbox[0].checked = !endDateMatchToday || this.state.fixEndDate;
      fixStartCheckbox[0].disabled = fixEndCheckbox[0].checked;
      fixStartCheckbox[0].checked = fixEndCheckbox[0].checked || this.state.fixStartDate;

      this.setState({
        fixStartDate: fixStartCheckbox[0].checked,
        fixEndDate: fixEndCheckbox[0].checked 
      }, () => this.notificationBar());
    }
  }

  handleChange = (event, picker) => {
    const customDate = this.state.fixStartDate && this.state.fixEndDate;
    const fixedStartDate = this.state.fixStartDate;
    
    const dates = {
      ...this.props.value,
      startDate: picker.startDate.startOf('day'),
      endDate: picker.endDate.endOf('day'),
      daysFromStart: picker.endDate.diff(picker.startDate, 'days'),
      fixedStartDate,
      customDate,
    };

    if (this.props.updateValue) {
      const update = this.props.dashboard && 
        (
          !this.props.dashboard.dataFrom ||
          moment(this.props.dashboard.dataFrom).isSameOrBefore(dates.startDate)
        );
      this.props.updateValue(dates, update);
      if (!this.props.disableSave && this.props.saveConfig) {
        this.props.saveConfig(update);
      }
    }
  };

  handleShow = () => {
    this.setCheckBoxes();
  }

  handleHide = () => {
    // Don't reset state to null on hide - this was causing the issue
    // where handleChange would see null values when saving
  }

  render() {
    const { dateFormat, value, switchConnection } = this.props;
    const { label, ranges } = this.state;

    return (
      <div className='datepicker'>
        <DateRangePicker
          locale={{ format: dateFormat, firstDay: 1 }}
          startDate={value.startDate}
          endDate={value.endDate}
          ranges={ranges}
          onApply={this.handleChange}
          onShow={this.handleShow}
          onHide={this.handleHide}
          ref={this.pickerRef}
        >
          <Button className='selected-date-range-btn'>
            <div className='pull-left'>
            <Image src={Calendar} />
            </div>
            <div className='pull-right'>
              <span>{label}</span>
              <span className='caret'></span>
            </div>
          </Button>
        </DateRangePicker>
        { switchConnection && (<div className='overlay' onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          switchConnection();
        }}></div>) }
      </div>
    );
  }
}

DatePicker.propTypes = {
  value: PropTypes.object,
  dateFormat: PropTypes.string,
  dashboard: PropTypes.object,
  saveConfig: PropTypes.func,
  updateValue: PropTypes.func,
};

export { DatePicker as DateRangePicker };
